export const FETCH_CONNECTIONS_LOADING = 'FETCH_CONNECTIONS_LOADING';
export const FETCH_CONNECTIONS_COMPLETED = 'FETCH_CONNECTIONS_COMPLETED';
export const FETCH_CONNECTIONS_FAILED = 'FETCH_CONNECTIONS_FAILED';
export const RECEIVE_CONNECTIONS = 'RECEIVE_CONNECTIONS';
export const FILTER_CONNECTIONS = 'FILTER_CONNECTIONS';
export const FETCH_CERTIFICATES_LOADING = 'FETCH_CERTIFICATES_LOADING';
export const FETCH_CERTIFICATES_FAILED = 'FETCH_CERTIFICATES_FAILED';
export const RECEIVE_CERTIFICATE_NAMES = 'RECEIVE_CERTIFICATE_NAMES';
export const RESET_STATE = 'RESET_STATE';
